export const QuoteTypes = {
  ORGANIZATION: 'ORGANIZATION',
} as const;

export type QuoteType = (typeof QuoteTypes)[keyof typeof QuoteTypes];
